var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3337 7.5L13.707 5.64L13.9337 3.18L11.527 2.63333L10.267 0.5L8.00033 1.47333L5.73366 0.5L4.47366 2.62667L2.06699 3.16667L2.29366 5.63333L0.666992 7.5L2.29366 9.36L2.06699 11.8267L4.47366 12.3733L5.73366 14.5L8.00033 13.52L10.267 14.4933L11.527 12.3667L13.9337 11.82L13.707 9.36L15.3337 7.5ZM6.25366 10.1733L4.66699 8.57333C4.40699 8.31333 4.40699 7.89333 4.66699 7.63333L4.71366 7.58667C4.97366 7.32667 5.40033 7.32667 5.66033 7.58667L6.73366 8.66667L10.167 5.22667C10.427 4.96667 10.8537 4.96667 11.1137 5.22667L11.1603 5.27333C11.4203 5.53333 11.4203 5.95333 11.1603 6.21333L7.21366 10.1733C6.94032 10.4333 6.52033 10.4333 6.25366 10.1733Z",
    fill: "#0066FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedicon);
export default __webpack_public_path__ + "static/media/verified.icon.c9861b076f83252126b62b5970335c26.svg";
export { ForwardRef as ReactComponent };